import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useJobOpportunities } from "../../../Pages.hook";
import { fields } from "../../../constants";

export const AddEditJobOpportunities = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editNews,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetcheditNews,
  } = useJobOpportunities(query.get("editId") || "");

  const {
    data: newsById,
    isLoading: isLoadingNews,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetcheditNews();
    }
  }, [query.get("editId"), query.get("id")]);

  console.log("news", newsById, "edit", editNews?.[0]);

  const newsFormConfig: FormConfig = {
    initialValues: {
      title_en: decodeHTML(newsById?.payload?.title_en ?? editNews?.[0]?.title_en ?? ""),
      title_ms: decodeHTML(newsById?.payload?.title_ms ?? editNews?.[0]?.title_ms ?? ""),
      field_start_date: newsById?.payload?.field_start_date ?? editNews?.[0]?.field_start_date ?? "",
      field_end_date: newsById?.payload?.field_end_date ?? editNews?.[0]?.field_end_date ?? "",
      title_zh: decodeHTML(newsById?.payload?.title_zh ?? editNews?.[0]?.title_zh ?? ""),
      field_content_description_en: decodeHTML(
        newsById?.payload?.field_content_description_en ?? editNews?.[0]?.field_content_description_en ?? ""
      ),
      field_content_description_ms: decodeHTML(
        newsById?.payload?.field_content_description_ms ?? editNews?.[0]?.field_content_description_ms ?? ""
      ),
      field_content_description_zh: decodeHTML(
        newsById?.payload?.field_content_description_zh ?? editNews?.[0]?.field_content_description_zh ?? ""
      ),

      published: decodeHTML(newsById?.payload?.published ?? editNews?.[0]?.published ?? ""),

      // image: decodeHTML([
      //   {
      //     uid: "-1",
      //     name: "newsImage.png",
      //     status: "done",
      //     url: newsById?.payload?.image ?? editNews?.[0]?.image ?? "",
      //   },
      // ]),
    },
    fields: fields.jobOpportunities,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: "aboutEraman_careers_jobOpportunities",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editNews?.[0]?.id || newsById?.payload?.id }),
        ...data,
        // published: true,
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingNews}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Job Opportunities`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingNews || drilldownLoading}
        config={newsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/job-opportunities-list-page-crud-api/${editNews?.[0]?.id || newsById?.payload?.id}` : `${eramanHost}/api/create/job-opportunities-list-page-crud-api`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
